/* SENTINEL theme JS */
(function () {
  'use strict';
  var S = window.SENTINEL || {};
  var STR = S.strings || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var fmt = S.moneyFormat || 'AED {{amount}}';
    var amount = Number(cents) || 0;

    function withDelimiters(precision, thousands, decimal) {
      var parts = (amount / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDelimiters(2, ',', '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelimiters(2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDelimiters(0, ',', '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDelimiters(0, '.', ','))
      .replace(/<[^>]*>/g, '');
  }

  /* ---------- Drawers ---------- */
  /* Move drawers rendered inside sections (e.g. header) to <body>, so they
     escape the sticky header's stacking context and sit above the overlay. */
  function relocateDrawers(scope) {
    $$('.drawer', scope || document).forEach(function (d) {
      if (d.closest('#CartDrawerSection')) return;
      if (!d.id) return;
      var existing = document.body.querySelector(':scope > #' + d.id);
      if (existing && existing !== d) existing.remove();
      if (d.parentElement !== document.body) document.body.appendChild(d);
    });
  }
  relocateDrawers();
  document.addEventListener('shopify:section:load', function (e) { relocateDrawers(e.target); });

  var overlay = document.createElement('div');
  overlay.className = 'drawer-overlay';
  document.body.appendChild(overlay);
  var openDrawer = null;

  function drawerOpen(id) {
    var d = document.getElementById(id);
    if (!d) return;
    if (openDrawer && openDrawer !== d) openDrawer.classList.remove('open');
    d.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('no-scroll');
    openDrawer = d;
    var f = d.querySelector('input, button.drawer__close');
    if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 250);
  }
  function drawerClose() {
    var y = window.scrollY;
    if (openDrawer && document.activeElement && openDrawer.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    if (openDrawer) openDrawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
    openDrawer = null;
    window.scrollTo(0, y);
  }
  overlay.addEventListener('click', drawerClose);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawerClose(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); drawerOpen(t.getAttribute('data-drawer-open')); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); drawerClose(); }
  });
  window.SentinelDrawer = { open: drawerOpen, close: drawerClose };

  /* ---------- Sticky header ---------- */
  var header = $('.site-header');
  if (header) {
    if (header.classList.contains('is-sticky')) {
      var headerWrap = header.closest('.shopify-section');
      if (headerWrap) headerWrap.classList.add('sticky-active');
    }
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Back to top ---------- */
  var btt = $('[data-back-to-top]');
  if (btt) {
    window.addEventListener('scroll', function () {
      btt.classList.toggle('show', window.scrollY > 700);
    }, { passive: true });
    btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Reveal on scroll ---------- */
  if (S.enableReveal && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Marquee: duplicate content for seamless loop ---------- */
  $$('.announcement--marquee .announcement__inner').forEach(function (inner) {
    inner.innerHTML += inner.innerHTML;
  });

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(parseInt(input.min, 10) || 1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var holder = document.getElementById('CartDrawerSection');
        if (holder && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = tmp.querySelector('#CartDrawerSection') || tmp.firstElementChild;
          holder.innerHTML = fresh.innerHTML;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        if (openAfter) drawerOpen('CartDrawer');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = STR.adding || 'ADDING…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || 'Error');
        if (S.cartType === 'page') { window.location.href = '/cart'; return; }
        return refreshCartDrawer(true);
      })
      .catch(function (err) {
        alert(err.message || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = orig; }
      });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(rm.getAttribute('data-cart-remove'), 10), quantity: 0 })
      }).then(function () {
        if (document.body.classList.contains('template-cart')) { if (!window.AEAEnquiryNavigating) window.location.reload(); }
        else { refreshCartDrawer(false); }
      });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    window.AEAEnquiryPending = fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(input.getAttribute('data-cart-line-qty'), 10), quantity: parseInt(input.value, 10) })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { if (!window.AEAEnquiryNavigating) window.location.reload(); }
      else { refreshCartDrawer(false); }
    });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    function selectedOptions() {
      var opts = [];
      $$('[data-option-index]', root).forEach(function (group) {
        var i = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        var sel = group.querySelector('select');
        opts[i] = checked ? checked.value : (sel ? sel.value : null);
      });
      return opts;
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var btn = root.querySelector('[data-add-btn]');
      var stockEl = root.querySelector('[data-stock]');
      var skuEl = root.querySelector('[data-sku]');

      $$('[data-option-index]', root).forEach(function (group) {
        var lbl = group.querySelector('.opt-legend .sel');
        var checked = group.querySelector('input:checked');
        if (lbl && checked) lbl.textContent = checked.value;
      });

      if (!variant) {
        if (btn) { btn.setAttribute('disabled', ''); btn.textContent = STR.unavailable || 'UNAVAILABLE'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (skuEl && variant.sku) skuEl.textContent = (STR.sku || 'SKU') + ': ' + variant.sku;
      if (btn) {
        if (variant.available) { btn.removeAttribute('disabled'); btn.innerHTML = btn.getAttribute('data-label-add') || STR.addToCart || 'ADD TO ENQUIRY LIST'; }
        else { btn.setAttribute('disabled', ''); btn.textContent = STR.soldOut || 'SOLD OUT'; }
      }
      if (stockEl) {
        stockEl.className = 'stock-dot ' + (variant.available ? 'in' : 'out');
        stockEl.textContent = variant.available ? (stockEl.getAttribute('data-label-in') || STR.inStock || 'In stock') : (stockEl.getAttribute('data-label-out') || STR.soldOutShort || 'Sold out');
      }
      if (variant.featured_media && window.SentinelGallery) window.SentinelGallery.goToMedia(variant.featured_media.id);
      if (history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) onChange();
    });
  });

  /* ---------- Product gallery ---------- */
  var gallery = $('[data-gallery]');
  if (gallery) {
    var slides = $$('.g-slide', gallery);
    var thumbs = $$('.gallery-thumbs button');
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('active'); }));
    function goTo(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('active', j === current); });
      thumbs.forEach(function (t, j) { t.classList.toggle('active', j === current); });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = $('[data-gallery-prev]'), next = $('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    window.SentinelGallery = {
      goToMedia: function (mediaId) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == mediaId; });
        if (idx > -1) goTo(idx);
      }
    };
  }

  /* ---------- Carousels ---------- */
  $$('[data-carousel-wrap]').forEach(function (wrap) {
    var track = $('.carousel', wrap);
    if (!track) return;
    var prev = $('[data-car-prev]', wrap), next = $('[data-car-next]', wrap);
    function step() {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach(function (show) {
    var slides = $$('.hero', show);
    if (slides.length < 2) return;
    var dots = $$('.slideshow__dots button', show);
    var i = 0, timer = null;
    var autoplay = parseInt(show.getAttribute('data-autoplay'), 10) || 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    }
    function restart() { if (autoplay) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, autoplay * 1000); } }
    var p = $('[data-slide-prev]', show), n = $('[data-slide-next]', show);
    if (p) p.addEventListener('click', function () { go(i - 1); restart(); });
    if (n) n.addEventListener('click', function () { go(i + 1); restart(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
    restart();
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var nums = {
      d: $('[data-cd-d]', el), h: $('[data-cd-h]', el),
      m: $('[data-cd-m]', el), s: $('[data-cd-s]', el)
    };
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5),
          m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      if (nums.d) nums.d.textContent = String(d).padStart(2, '0');
      if (nums.h) nums.h.textContent = String(h).padStart(2, '0');
      if (nums.m) nums.m.textContent = String(m).padStart(2, '0');
      if (nums.s) nums.s.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Count-up stats ---------- */
  if ('IntersectionObserver' in window) {
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        statIO.unobserve(en.target);
        var el = en.target, target = parseFloat(el.getAttribute('data-count-up')) || 0;
        var dur = 1400, start = performance.now();
        function frame(t) {
          var p = Math.min(1, (t - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString();
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    $$('[data-count-up]').forEach(function (el) { statIO.observe(el); });
  }

  /* ---------- Age gate ---------- */
  var gate = $('#AgeGate');
  if (gate) {
    try {
      if (localStorage.getItem('sentinel_age_ok') !== '1') {
        gate.classList.add('open');
        document.body.classList.add('no-scroll');
      }
    } catch (err) { gate.classList.add('open'); }
    var yes = $('[data-age-yes]', gate), no = $('[data-age-no]', gate);
    if (yes) yes.addEventListener('click', function () {
      try { localStorage.setItem('sentinel_age_ok', '1'); } catch (err) {}
      gate.classList.remove('open');
      document.body.classList.remove('no-scroll');
    });
    if (no) no.addEventListener('click', function () {
      window.location.href = no.getAttribute('data-url') || 'https://www.google.com';
    });
  }

  /* ---------- Predictive search ---------- */
  var psInput = $('[data-predictive-input]');
  var psResults = $('[data-predictive-results]');
  if (psInput && psResults && S.predictiveSearch) {
    var psTimer;
    psInput.addEventListener('input', function () {
      clearTimeout(psTimer);
      var q = psInput.value.trim();
      if (q.length < 2) { psResults.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { psResults.innerHTML = '<p style="color:var(--c-muted);font-size:13px;padding:14px 0;">' + (STR.noResults || 'No results for') + ' “' + q.replace(/</g, '&lt;') + '”</p>'; return; }
            psResults.innerHTML = items.map(function (p) {
              return '<a class="predictive-item" href="' + p.url + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=104" alt="">' : '<span style="width:52px;height:52px;background:var(--c-surface);flex-shrink:0;"></span>') +
                '<span><span class="t">' + p.title + '</span></span></a>';
            }).join('') +
            '<a class="btn btn--ghost" style="margin-top:12px;" href="/search?q=' + encodeURIComponent(q) + '">VIEW ALL RESULTS →</a>';
          });
      }, 250);
    });
  }

  /* ---------- Facets: auto submit ---------- */
  var facetsForm = $('#FacetsForm');
  if (facetsForm) {
    facetsForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) facetsForm.submit();
    });
    var ft = $('[data-facets-toggle]');
    if (ft) ft.addEventListener('click', function () { $('.facets').classList.toggle('open'); });
  }
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Video cover ---------- */
  document.addEventListener('click', function (e) {
    var cover = e.target.closest('[data-video-cover]');
    if (!cover) return;
    var wrap = cover.parentElement;
    var src = cover.getAttribute('data-video-src');
    if (src) {
      var iframe = document.createElement('iframe');
      iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      iframe.allow = 'autoplay; fullscreen';
      iframe.setAttribute('frameborder', '0');
      wrap.appendChild(iframe);
    }
    cover.remove();
  });
})();
